import { useNearestOpenShifts } from "@src/appV2/redesign/Shift/NearestOpenShifts/useNearestOpenShifts";
import type { OpenShift, OpenShiftWorkplace } from "@src/appV2/redesign/Shift/Open/types";

import { DEFAULT_DISTANCE_IN_MILES_FILTER } from "../Filters/constants";

// `/open-shifts` does not support cursor/offset paging — see plan PR 3 key context.
// 200 is a single-request ceiling well under the BFF cap of 5000.
const TRAVEL_FOR_MORE_SHIFTS_PAGE_SIZE = 200;

interface UseTravelForMoreShiftsResult {
  shifts: OpenShift[];
  workplacesMap: Map<string, OpenShiftWorkplace>;
  isLoading: boolean;
  isSuccess: boolean;
  isError: boolean;
}

interface UseTravelForMoreShiftsParams {
  enabled: boolean;
}

/**
 * Wraps `useNearestOpenShifts` with a floor at the max user-configurable distance
 * filter, so shifts already reachable on the main list view are excluded.
 */
export function useTravelForMoreShifts(
  params: UseTravelForMoreShiftsParams
): UseTravelForMoreShiftsResult {
  const { enabled } = params;

  const { shifts, workplacesMap, isLoading, isSuccess, isError } = useNearestOpenShifts({
    enabled,
    pageSize: TRAVEL_FOR_MORE_SHIFTS_PAGE_SIZE,
    minimumDistanceInMilesFloor: DEFAULT_DISTANCE_IN_MILES_FILTER,
  });

  return {
    shifts,
    workplacesMap,
    isLoading,
    isSuccess,
    isError,
  };
}
